import { CalendarWidget, TimetableWidget } from "./components";
import styles from "./RightSidebar.module.css";

const RightSidebar = ({ isOpen }) => {
	return (
		<div className={`${styles.rightSidebar} ${isOpen ? styles.open : ""}`}>
			<div className={styles.scrollContainer}>
				<div className={styles.calendarWrapper}>
					<CalendarWidget />
				</div>
				<div className={styles.timetableWrapper}>
					<TimetableWidget />
				</div>
			</div>
		</div>
	);
};

export default RightSidebar;
